module.exports = __webpack_public_path__ + "assets1783936157458/img/lianjie.e31105a7.svg";